<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-input class="search-el" size="mini" v-model="query.mobile" placeholder="请输入手机号"></el-input>
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="key" label="手机号"></el-table-column>
        <el-table-column prop="value" label="验证码"></el-table-column>
        <el-table-column prop="ttl" label="过期时间" ></el-table-column>
      </el-table>

    </el-row>
  </div>
</template>

<script>
import {
  smsList
} from "@/api/sms";

export default {
  data:function () {
    return {
      id: '',
      listData:[],
      listLoading:false,
      query:{
        mobile:''
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      smsList(this.query).then(response => {
        this.listData = response.data
        this.listLoading = false;
      });
    },
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>